import { render, staticRenderFns } from "./ModalAlertNoX.vue?vue&type=template&id=5fb4b799&scoped=true"
import script from "./ModalAlertNoX.vue?vue&type=script&lang=js"
export * from "./ModalAlertNoX.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertNoX.vue?vue&type=style&index=0&id=5fb4b799&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4b799",
  null
  
)

export default component.exports